import React from 'react';
import { ContentProps } from '../../content/types';
import { Instructions } from '../../content/instructions';
import { Upsell } from './upsell';
import { UpsellContent } from './types';

export function UpsellContentElement(props: Readonly<ContentProps>) {
  const { instructions = {}, componentSettings } = props;
  const instr = new Instructions(instructions, componentSettings);

  const content: UpsellContent = {
    heading: instr.getString('heading', ''),
    bulletPoints: instr.getStringList('bulletPoints', []) || [],
    callToAction: instr.getString('callToAction', ''),
    buttonText: instr.getString('buttonText', ''),
    imageKey: instr.getString('imageKey', ''),
  };

  return <Upsell content={content} />;
}
